import React from 'react'
import {useSelector} from 'react-redux'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import PopupAtom from '../../@atoms/to_layout/popup/popup.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import {RootState} from '../../store_redux'
import {PopupState} from '../../props_reusable'

interface PopupComponentProps extends PopupState {
  cancelButton: () => void | undefined
  okButton: () => void | undefined
}

const PopupComponent: React.FC<Omit<PopupComponentProps, 'type'>> = function ({
  open,
  cancelButton,
  okButton,
}) {
  const labels = useSelector((state: RootState) => state.labels)

  const renderTitle = () => (
    <TypographyAtom ap_type="h6">
      {labels.notificationModal.cancelPopup.title}
    </TypographyAtom>
  )

  const renderContent = () => (
    <TypographyAtom ahd_type="sData">
      {labels.notificationModal.cancelPopup.content}
    </TypographyAtom>
  )

  const renderActions = () => (
    <>
      <ButtonAtom ap_type="secondary" onClick={cancelButton}>
        {labels.notificationModal.cancelPopup.buttonCancel}
      </ButtonAtom>
      <ButtonAtom ap_type="primary" onClick={okButton}>
        {labels.notificationModal.cancelPopup.buttonOk}
      </ButtonAtom>
    </>
  )

  return open ? (
    <PopupAtom
      open={open}
      ap_name="notify_prefs_cancel_popup"
      renderActions={renderActions}
      renderContent={renderContent}
      renderTitle={renderTitle}
    />
  ) : null
}

export default PopupComponent
